import {type ICarrierAdminAuthorizationConfig} from 'shared/Header/components/data'

export interface ICarrierAdminACPageAccessRights {
    OfferMenu: string
    ManageACSpotRATEOffers: string
    ViewACSPOTofferqueue: string
    Marketplace: string
    Booking: string
    SearchAvailabilityAndPrice: string
    SearchAvailableSpace: string
    SearchAirWaybillStock: string
    CreateModifyBookingNew: string
    CreateModifyBookingOld: string
    CreateMultipleBookings: string
    CreateModifyBookingTemplates: string
    CreateSpreadsheetBookings: string
    CreateAirWaybillStockRequest: string
    CreateAllotmentRequest: string
    ViewAllotmentStatus: string
    ViewRateEstimate: string
    ViewCarrierSchedules: string
    UpdateAirWaybillStatus: string
    Efreight: string
    CreateRetrieveMAWB: string
    CreateModifyHAWB: string
    CreateModifyHAWBTemplates: string
    CreateModifyPieceIDInfo: string
    ManageShipments: string
    TrackShipments: string
    SearchAirWaybills: string
    ViewModifyBooking: string
    ReviewActiveQueuedBookings: string
    PrintBarcodeShippingLabel: string
    PrintShipperLetterOfInstruction: string
    MakeOnlinePayments: string
    ViewFlightStatus: string
    ViewCustomsStatus: string
    ViewArchivedAirWaybill: string
    ShipmentReleaseDeclaration: string
    eClaims: string
    FileDamageReport: string
    ViewDamageReportStatus: string
    CreateModifyPreliminaryClaim: string
    CreateModifyFinalClaim: string
}

export interface ICarrierAdminACAuthorizationConfig {
    isAministratorStatus: boolean
    isLevelofAdminRight: boolean
    isGSAStatus: boolean
    isAllocation: boolean
    isRating: boolean
}

const CarrierAdminAC = () => {
    const carrierAdminACConfigKey1: ICarrierAdminACAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminACValue1: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // Create more CarrierAdminAuthorizationConfig instances for other configurations

    const carrierAdminACConfigKey2: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminACValue2: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey3: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminACValue3: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey4: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminACValue4: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey5: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminACValue5: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey6: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminACValue6: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey7: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminACValue7: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey8: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminACValue8: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // AministratorStatus is denied

    const carrierAdminACConfigKey9: ICarrierAdminACAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminACValue9: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey10: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminACValue10: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey11: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminACValue11: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey12: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminACValue12: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey13: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminACValue13: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey14: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminACValue14: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey15: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminACValue15: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey16: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminACValue16: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'Y',
        ViewACSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // GSA Status Denied

    const carrierAdminACConfigKey17: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: false,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminACValue17: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'N',
        ViewACSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminACConfigKey18: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: false,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminACValue18: ICarrierAdminACPageAccessRights = {
        OfferMenu: 'Y',
        ManageACSpotRATEOffers: 'N',
        ViewACSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const adminHashMap = new Map<ICarrierAdminAuthorizationConfig, ICarrierAdminACPageAccessRights>()
    adminHashMap.set(carrierAdminACConfigKey1, carrierAdminACValue1)
    adminHashMap.set(carrierAdminACConfigKey2, carrierAdminACValue2)
    adminHashMap.set(carrierAdminACConfigKey3, carrierAdminACValue3)
    adminHashMap.set(carrierAdminACConfigKey4, carrierAdminACValue4)
    adminHashMap.set(carrierAdminACConfigKey5, carrierAdminACValue5)
    adminHashMap.set(carrierAdminACConfigKey6, carrierAdminACValue6)
    adminHashMap.set(carrierAdminACConfigKey7, carrierAdminACValue7)
    adminHashMap.set(carrierAdminACConfigKey8, carrierAdminACValue8)
    adminHashMap.set(carrierAdminACConfigKey9, carrierAdminACValue9)
    adminHashMap.set(carrierAdminACConfigKey10, carrierAdminACValue10)
    adminHashMap.set(carrierAdminACConfigKey11, carrierAdminACValue11)
    adminHashMap.set(carrierAdminACConfigKey12, carrierAdminACValue12)
    adminHashMap.set(carrierAdminACConfigKey13, carrierAdminACValue13)
    adminHashMap.set(carrierAdminACConfigKey14, carrierAdminACValue14)
    adminHashMap.set(carrierAdminACConfigKey15, carrierAdminACValue15)
    adminHashMap.set(carrierAdminACConfigKey16, carrierAdminACValue16)
    adminHashMap.set(carrierAdminACConfigKey17, carrierAdminACValue17)
    adminHashMap.set(carrierAdminACConfigKey18, carrierAdminACValue18)

    return adminHashMap
}
export default CarrierAdminAC
